import { Navigate } from "react-router-dom";
import { useSession } from "../auth/SessionContext.jsx";

/** "/" always bounces to a real named route - it is never itself a distinct view. */
export default function RootRedirect() {
  const { isAuthenticated } = useSession();
  return <Navigate to={isAuthenticated ? "/backoffice" : "/login"} replace />;
}
